import CustomLink from "./CustomLink";
import styles from "./Logo.module.css";
import classNames from "classnames";

export default function Logo({ isMenuOpen }) {
  return (
    <div
      className={classNames({
        [styles.logoWrapper]: true,
        [styles.active]: isMenuOpen,
      })}
    >
      <CustomLink href="/" className={styles.Logo}>
        Crew Studio.
      </CustomLink>
    </div>
  );
}
